import script from "./WindowInactivityController.vue?vue&type=script&setup=true&lang=js"
export * from "./WindowInactivityController.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__